import { useMutation } from "react-query";
import { editSingleAlarm } from "../../../../actions/CarrierAgreementMgmt/Security";

const useEditSingleAlarm = () => {
  return useMutation(editSingleAlarm);
};
export default useEditSingleAlarm;
